import { render } from "./ProLicense.vue?vue&type=template&id=8ea2834e"
import script from "./ProLicense.vue?vue&type=script&lang=js"
export * from "./ProLicense.vue?vue&type=script&lang=js"

import "./ProLicense.vue?vue&type=style&index=0&id=8ea2834e&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__